import { Action } from 'redux'

import { SET_SERVICE_STATUS } from '../../actions/service/setServiceStatus'
import { CLOSE_GLOBAL_MESSAGE } from '../../actions/globalMessage/closeGlobalMessage'

export interface ServiceStatusState {
    isGlobalMessageVisible: false,
    isGlobalMessageRemovable: true,
    isGlobalMessageRemoved: false,
}

export const initialState: ServiceStatusState = {
    isGlobalMessageVisible: false,
    isGlobalMessageRemovable: true,
    isGlobalMessageRemoved: false,
}

interface StatusAction extends Action {
    data?: any
}

export default (state = initialState, action: StatusAction = { type: ''}) => {
    switch (action.type) {
        case SET_SERVICE_STATUS:
            // If banner is removed by the user, it should not reapear at polling
            if (state.isGlobalMessageRemoved === false || action.data.isGlobalMessageRemovable !== state.isGlobalMessageRemovable){
                return {
                    ...state,
                    ...action.data
                }
            } else {
                return {...state }
            }
        case CLOSE_GLOBAL_MESSAGE:
            return {
                ...state,
                isGlobalMessageVisible: false,
                isGlobalMessageRemoved: true
            }
        default:
            return state
    }
}
